module.exports = new __parcel__URL__("note-scroll.ea3f9b0a.png").toString();